import "./Founders.module.css";
import Header from "@/reusable_sections/Header";
import Founders from "./sections/Founders";
import Footer from "@/reusable_sections/Footer";
export default function FoundersPage() {
  return <div>
      <Header />
      <Founders />
      <Footer />
    </div>;
}